<script setup lang="ts">
import { XModal, XLink } from '@clicksign/excalibur';
import { useI18n } from '#i18n';

import { HELP_LINKS } from '~~core';
import { BrandButton } from '~~base-ui';

export type DigitalCertificateErrorModalProps = {
  error: string;
};

export type DigitalCertificateErrorModalEmit = {
  (event: 'close'): void;
};

const emit = defineEmits<DigitalCertificateErrorModalEmit>();
const props = defineProps<DigitalCertificateErrorModalProps>();

const { t } = useI18n();
const title = computed(() => t(`requirement.digitalCertificate.local.modal.${props.error}.title`));
</script>

<template>
  <XModal
    :is-open="true"
    :title="title"
    role="dialog"
    :data-testid="`${props.error}ErrorModal`"
    :close-button="false"
  >
    <template #default>
      <p>{{ $t(`requirement.digitalCertificate.local.modal.${props.error}.description`) }}</p>

      <XLink
        target="_blank"
        is-inline
        :to="HELP_LINKS.requirement.digitalCertificate"
      >
        {{ $t(`requirement.digitalCertificate.local.modal.accessError.link`) }}
      </XLink>
    </template>

    <template #actions>
      <BrandButton
        data-testid="modalCloseButton"
        @click="emit('close')"
      >
        {{ $t('requirement.common.close') }}
      </BrandButton>
    </template>
  </XModal>
</template>
